<template>
  <div>
    <div
      v-touch:start="onMousePressed"
      v-touch:end="onMouseReleased"
      v-touch:moving="changePos"
      class="mainRow"
      :style="mocolor">

      <div @click="setIsEdit" class="time">
        <div class="percent-visualisation"></div>
      </div>

      <div class="chrono">
        <div>
          <p class="mo-duration">
            {{ getDuration(manufacturingOrder.start, manufacturingOrder.end) }}</p>
          <p class="mo-data">{{ getProductionZoneName(manufacturingOrder.productionArea) }}</p>
          <p class="mo-name">{{ manufacturingOrder.manufacturingOrder }}</p>
        </div>
        <div class="time-in-row">
          <div>
            <p>{{ getTime(manufacturingOrder.start) }}</p>
          </div>
          <div>
            <p>{{ getTime(manufacturingOrder.end) }}</p>
          </div>
        </div>
      </div>
      <div class="options-background">
        <div class="edit-option" :class="{'add-delete-options': canDelete}" v-if="canEdit">
          <div @click="editRow">
            <p>{{ $t('timesheet.edit') }}</p>
            <div :class="{'edit-icon': canEdit}">
              <img
                src="../assets/edit.svg"
                alt="settings"
                height="30px"
              />
            </div>
          </div>
          <div v-if="canDelete" @click="deleteRow" class="delete-button">
            <p>{{ $t('timesheet.delete') }}</p>
            <div :class="{'edit-icon': canEdit}">
              <img
                src="../assets/delete_white.svg"
                alt="settings"
                height="30px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getDuration from '../mixins/getDuration';
import getTime from '../mixins/getTime';
import getLighterColor from '../mixins/getLighterColor';

export default {
  props: {
    manufacturingOrder: {
      type: Object,
      default: () => ({
        start: '00H00',
        duration: '01H00',
        of: 'ordre de fab inconnu',
        productionZone: 'Unknow production area',
        color: '#777777',
      }),
    },
    idx: {
      type: Number,
    },
    totalTimeCollected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isEdit: false,
      infoOpacity: 1,
      gridFull: 2,
      infoTextColor: '#000000',
      isDrawing: false,
      pmouseX: 0,
      startDrawingX: 0,
      isTouched: '',
      editOption: '-15vw',
      hasVibrate: false,
      canEdit: false,
      canDelete: false,
      onEditing: false,
      isSuperAdmin: false,
    };
  },
  // -- USE TO DEBUG POSITION - SHOULD BE DELETED ON THE PRODUCTION VERSION
  // created() {
  //   console.log('CREATED this.manufacturingOrder: ', this.manufacturingOrder);
  // },
  // mounted() {
  //   console.log('position bottom the component: ', this.$el.offsetTop + this.$el.offsetHeight);
  //   console.log('position top the component: ', this.$el.offsetTop);
  // },
  created() {
    this.isSuperAdmin = this.$store.getters.isSuperAdmin;
  },
  watch: {
    canEdit(nVal) {
      if (nVal) {
        window.navigator.vibrate(45);
      }
    },
    canDelete(nVal) {
      if (nVal) {
        window.navigator.vibrate(45);
      }
    },
    getCloseAllTimeRows() {
      if (!this.onEditing) {
        this.canEdit = false;
        this.canDelete = false;
        this.vibrate = false;
        if (this.$el !== undefined && this.$el.style.marginLeft !== undefined) {
          this.$el.style.marginLeft = '0px';
        }
      }
    },
  },
  computed: {
    mocolor() {
      const idle = '#607D8B';
      let colorRow = idle;
      if (this.manufacturingOrder.productionArea) {
        colorRow = this.manufacturingOrder.color ? this.manufacturingOrder.color : '#32A6ED';
      }
      return {
        '--main-color': this.getLighterColor(colorRow),
        '--chart-color': colorRow,
        '--info-text-color': this.infoTextColor,
        '--row-height': this.getRowHeight(this.getDuration(this.manufacturingOrder.start, this.manufacturingOrder.end)),
        '--info-opacity': this.infoOpacity,
        '--flux': this.gridFull,
        '--edit-option': this.editOption,
        '--percent-chart': this.getPercentOfTotal(),
      };
    },
    getCloseAllTimeRows() {
      return this.$store.getters.getCloseAllTimeRows;
    },
    getDurationInTS() {
      return this.manufacturingOrder.end - this.manufacturingOrder.start;
    },
  },
  methods: {
    getRowHeight(time) {
      const hours = (time.split('H')[0]);
      const multiplicator = Number(hours);
      return multiplicator > 0 ? `${multiplicator * 10}em` : '10em';
    },
    setIsEdit() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        this.infoOpacity = 1;
        this.gridFull = 3;
        this.infoTextColor = '#ffffff';
      } else {
        this.infoOpacity = 0.6;
        this.gridFull = 2;
        this.infoTextColor = '#000000';
      }
      this.$emit('timerow', this.isEdit);
    },
    onMousePressed(evt) {
      this.isTouched = 'onMousePressed';
      this.isDrawing = true;
      this.startDrawingX = evt.touches[0].clientX;
      this.pmouseX = evt.touches[0].clientX;
    },
    changePos(evt) {
      this.isTouched = 'move';
      this.onEditing = true;
      this.$store.dispatch('closeAllTimeRows');
      if (this.isDrawing) {
        if (Math.abs((evt.touches[0].clientX - this.startDrawingX)) > 10) {
          this.pmouseX = evt.touches[0].clientX;
          this.$el.style.marginLeft = `${evt.touches[0].clientX - this.startDrawingX}px`;
        } else if ((this.pmouseX - evt.touches[0].clientX) > 50) {
          this.vibrate = false;
          this.$el.style.marginLeft = '0px';
        }
      }
      if (evt.touches[0].clientX - this.startDrawingX < -50) {
        this.canEdit = true;
        if (evt.touches[0].clientX - this.startDrawingX < -100) {
          this.canDelete = true;
        } else {
          this.canDelete = false;
        }
      } else {
        this.canEdit = false;
        this.canDelete = false;
      }
    },
    onMouseReleased() {
      this.isTouched = 'onMouseReleased';
      this.onEditing = false;
      this.isDrawing = false;
      this.hasVibrate = false;
      if (!this.canDelete) {
        this.$el.style.marginLeft = '0px';
        if (this.canEdit && this.isSuperAdmin) {
          this.$router.push({ name: 'edit-time-row', params: { manufacturingOrder: this.manufacturingOrder, idx: this.idx } });
        }
      } else {
        this.$el.style.marginLeft = '-32vw';
      }
    },
    editRow() {
      if (this.isSuperAdmin) {
        this.$router.push({ name: 'edit-time-row', params: { manufacturingOrder: this.manufacturingOrder, idx: this.idx } });
      }
    },
    deleteRow() {
      if (this.isSuperAdmin) {
        this.$store.dispatch('deleteRow', this.manufacturingOrder)
          .then((response) => {
            if (response) {
              window.location.reload();
            }
          });
      }
    },
    getPercentOfTotal() {
      const durationTS = this.manufacturingOrder.end - this.manufacturingOrder.start;
      return `${Math.round(100 * durationTS / this.totalTimeCollected)}%`;
    },
    getProductionZoneName(pzID) {
      const pz = this.$store.getters.getProductionZones;
      const zoneName = pz.find(zone => zone.nodeId === pzID);
      if (zoneName === undefined) {
        return 'n/c';
      }
      return zoneName.name;
    },
  },
  mixins: [getDuration, getTime, getLighterColor],
};
</script>

<style scoped>
  .mainRow {
    display: grid;
    grid-template-columns: 30vw 70vw auto;
    grid-auto-rows: minmax(100px, auto);
  }

  .time {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row: 1;
    background-color: var(--main-color);
    border-right: 1px solid var(--chart-color);
  }

  .percent-visualisation {
    background-color: var(--chart-color);
    width: var(--percent-chart);
    height: 100%;
  }

  .chrono {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row: 1;
    background-color: var(--main-color);
    padding-top: 0.6em;
    padding-bottom: 0.6em;
    padding-right: 1em;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .chrono > div > p {
    text-align: left;
    color: var(--info-text-color);
    padding-left: 24px;
    margin-top: 0;
    margin-bottom: 0;
  }

  .mo-duration {
    font-size: 24px;
    font-weight: 800;
  }

  .mo-data {
    font-size: 18px;
    font-weight: normal;
  }

  .mo-name {
    font-size: 14px;
    font-weight: bold;
  }

  .time-in-row {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .time-in-row > div > p {
    margin-bottom: 0;
    margin-top: 0;
    color: #000000;

  }

  .options-background {
    background-color: #32A6ED;
  }

  .edit-option {
    color: #ffffff;
    height: 100%;
  }

  .edit-option > div {
    border-right: 1px solid grey;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    height: 100%;
    font-size: 0.8em;
    font-weight: bold;
  }

  .add-delete-options {
    display: grid;
    grid-template-columns: 50% 50%;
    align-items: center;
  }

  .delete-button {
    background-color: #ED3D62;
  }
  .edit-icon {
    border-radius: 50%;
    animation-name: bottomToTop;
    animation-duration: 0.3s;
    animation-iteration-count: 1;
  }

  @keyframes bottomToTop {
    0% {
      opacity: 0.3;
      transform: scale(.2);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>
